export default "__VITE_ASSET__56769a2c__"